import clone from 'lodash/clone'

const buildByAcceptors = (path: any, finalAcceptors: any, i: number) => {
    let infos = finalAcceptors.map(function (acceptor: any) {
        let p = i - acceptor.strOffset + 1
        let _info = path[p]

        let info = {
            p: p,
            mw: _info.mw + (acceptor.mw === undefined ? 0 : acceptor.mw),
            w: acceptor.w + _info.w,
            unk: (acceptor.unk ? acceptor.unk : 0) + _info.unk,
            type: acceptor.type
        }

        if (acceptor.type.toUpperCase() === "PART") {
            for (var j = p + 1; j <= i; j++) {
                path[j].merge = p
            }
            //@ts-ignore
            info.merge = p
        }

        return info
    })

    return infos.filter(function (info: any) {
        return info
    })
}

const fallback = (path: any, leftBoundary: number, text: string, i: number) => {
    let _info = path[leftBoundary]

    if (text[i].match(/[\u0E48-\u0E4E]/)) {
        if (leftBoundary !== 0) {
            leftBoundary = path[leftBoundary].p
        }

        return {
            p: leftBoundary,
            mw: 0,
            w: 1 + _info.w,
            unk: 1 + _info.unk,
            type: "UNK"
        }
        /*    else if(leftBoundary > 0 && path[leftBoundary].type !== "UNK") {
              leftBoundary = path[leftBoundary].p;
              return {p: leftBoundary,
                      w: 1 + _info.w,
                      unk: 1 + _info.unk,
                      type: "UNK"};            */
    } else {
        return {
            p: leftBoundary,
            mw: _info.mw,
            w: 1 + _info.w,
            unk: 1 + _info.unk,
            type: "UNK"
        }
    }
}

const build = (path: any, finalAcceptors: any, i: number, leftBoundary: number, text: string) => {
    let basicPathInfos = buildByAcceptors(path, finalAcceptors, i)

    if (basicPathInfos.length > 0) {
        return basicPathInfos
    } else {
        return [fallback(path, leftBoundary, text, i)]
    }
}

export const pathInfoBuilder = {
    buildByAcceptors,
    fallback,
    build
}

export const PathInfoBuilder = () => {
    return clone(pathInfoBuilder)
}